{
  "title": "Invoices",
  "table": {
    "searchPlaceholder": "Search invoices",
    "headers": {
      "invoiceName": "Invoice Name",
      "accountName": "Entity",
      "type": "Type",
      "inputDate": "Date Created",
      "valueDate": "Due Date",
      "debitAccountName": "Assigned Debit Account",
      "amount": "Amount",
      "status": "Status",
      "action": "Action"
    },
    "dataError": "Access to view invoices for the selected entities is restricted for the current user",
    "dropdown": {
      "downloadPDF": "Download PDF"
    }
  },
  "download": {
    "genericPDFError": "This invoice is not available. Please contact customer support.",
    "downloadLink": "There was an issue getting the invoice download link: {{error}}."
  }
}
